export const GET_CANDIDATE_REGISTERED_EXAM = 'GET_REGISTERED_EXAM';
export const GET_PENDING_REGISTRATION = 'GET_PENDING_REGISTRATION';
export const GET_EXAM_TYPES = 'GET_EXAM_TYPES';
export const POST_CREATE_EXAM_REGISTRATION = 'POST_CREATE_EXAM_REGISTRATION';
export const POST_CREATE_NON_EXAM_REGISTRATION = 'POST_CREATE_NON_EXAM_REGISTRATION';
export const POST_CANDIDATE_EXAM_PAYMENT = 'POST_CANDIDATE_EXAM_PAYMENT';
export const POST_CANDIDATE_EXAM_AMENDMENT_PAYMENT = 'POST_CANDIDATE_EXAM_AMENDMENT_PAYMENT';
export const GET_EXAM_TRANSACTION_INFO = 'GET_EXAM_TRANSACTION_INFO';
export const GET_EXAM_CANDIDATE_PROFILE = 'GET_EXAM_CANDIDATE_PROFILE';
export const POST_EXAM_REGISTRATION_CANDIDATE_PROFILE = 'POST_EXAM_REGISTRATION_CANDIDATE_PROFILE';
export const GET_EXAM_REGISTRATION = 'GET_EXAM_REGISTRATION';
export const GET_EXAM_SUMMARY_PDF = 'GET_EXAM_SUMMARY_PDF';
export const GET_EXAM_REGISTRATION_SUMMARY = 'GET_EXAM_REGISTRATION_SUMMARY';
export const DELETE_EXAM_REGISTRATION_CANDIDATE_DRAFT = 'DELETE_EXAM_REGISTRATION_CANDIDATE_DRAFT';
export const GET_SELECTED_SUBJECTS = 'GET_SELECTED_SUBJECTS';
export const GET_EXAM_SUBJECTS = 'GET_EXAM_SUBJECTS';
export const POST_EXAM_SUBJECT_REGISTRATION_DRAFT = 'POST_EXAM_SUBJECT_REGISTRATION_DRAFT';
export const PUT_EXAM_SUBJECT_REGISTRATION_DRAFT = 'PUT_EXAM_SUBJECT_REGISTRATION_DRAFT';
export const DELETE_EXAM_SUBJECT_REGISTRATION_DRAFT = 'DELETE_EXAM_SUBJECT_REGISTRATION_DRAFT';
export const GET_SUBJECT_DETAIL = 'GET_SUBJECT_DETAIL';
export const GET_EXAM_LEVEL = 'GET_EXAM_LEVEL';
export const POST_EXAM_LEVEL = 'POST_EXAM_LEVEL';
export const GET_EXAM_SERIES = 'GET_EXAM_SERIES';
export const GET_CANDIDATE_REGISTERED_SUBJECT = 'GET_CANDIDATE_REGISTERED_SUBJECT';
export const GET_LANGUAGES = 'GET_LANGUAGES';
export const POST_CREATE_EXAM_AMENDMENT = 'POST_CREATE_EXAM_AMENDMENT';
export const GET_REGISTERED_SUBJECTS = 'GET_REGISTERED_SUBJECTS';
export const PUT_DRAFT_SUBJECT_WITHDRAWAL = 'PUT_DRAFT_SUBJECT_WITHDRAWAL';
export const PUT_UNDO_DRAFT_SUBJECT_WITHDRAWAL = 'PUT_UNDO_DRAFT_SUBJECT_WITHDRAWAL';
export const POST_EXAM_SUBJECT_AMENDMENT_DRAFT = 'POST_EXAM_SUBJECT_AMENDMENT_DRAFT';
export const GET_CANDIDATE_REGISTERED_EXAM_AMENDMENT = 'GET_CANDIDATE_REGISTERED_EXAM_AMENDMENT';
export const PUT_EXAM_SUBJECT_AMENDMENT_DRAFT = 'PUT_EXAM_SUBJECT_AMENDMENT_DRAFT';
export const GET_EXAM_AMENDMENT_SUMMARY = 'GET_EXAM_AMENDMENT_SUMMARY';
export const GET_REVIEW_EXAM_AMENDMENT = 'GET_REVIEW_EXAM_AMENDMENT';
export const GET_EXAM__AMENDMENT_SUMMARY_PDF = 'GET_EXAM__AMENDMENT_SUMMARY_PDF';
export const POST_SUBJECT_VALIDATION = 'POST_SUBJECT_VALIDATION';
export const GET_CANDIDATE_TRANSACTION_HISTORY = 'GET_CANDIDATE_TRANSACTION_HISTORY';
export const GET_EXAM_WITHDRAWAL_DROPDOWN = 'GET_EXAM_WITHDRAWAL_DROPDOWN';
export const POST_EXAM_WITHDRAWAL_UPLOAD_DOCUMENT = 'POST_EXAM_WITHDRAWAL_UPLOAD_DOCUMENT';
export const PUT_EXAM_WITHDRAWAL_DETAILS = 'PUT_EXAM_WITHDRAWAL_DETAILS';
export const GET_WITHDRAWAL_DRAFT = 'GET_WITHDRAWAL_DRAFT';
export const GET_WITHDRAW_DETAILS = 'GET_WITHDRAW_DETAILS';
export const PUT_CONFIRM_WITHDRAW = 'PUT_CONFIRM_WITHDRAW';
export const GET_WITHDRAWAL_ACKNOWLEDGEMENT = 'GET_WITHDRAWAL_ACKNOWLEDGEMENT';
export const GET_WITHDRAWAL_DOWNLOAD_PDF = 'GET_WITHDRAWAL_DOWNLOAD_PDF';
export const GET_SUBMITTED_WITHDRAWAL = 'GET_SUBMITTED_WITHDRAWAL';
export const GET_EXAM_LEVEL_WITHDRAWAL = 'GET_EXAM_LEVEL_WITHDRAWAL';
export const GET_WITHDRAWAL_TIMESTAMP = 'GET_WITHDRAWAL_TIMESTAMP';
export const GET_PARENT_PARTICULAR_PROFILE = 'GET_PARENT_PARTICULAR_PROFILE'
